import React, { ComponentProps } from 'react';

import { Popover } from '@draft-js-plugins/mention';
import styled from 'styled-components';

import { Container } from '@adsk/alloy-react-helpers';
import { MenuList } from '@adsk/alloy-react-menu';
import Overlay from '@adsk/alloy-react-overlay';
import Portal from '@adsk/alloy-react-portal';
import theme from '@adsk/alloy-react-theme';

const StyledDiv = styled.div`
  .mention-suggestions-popup {
    z-index: ${theme.zIndex.tooltip};
  }
`;

export type MentionPopoverProps = ComponentProps<typeof Popover> &
  ComponentProps<typeof Overlay.Container> & {
    container?: Container;
  };

const MentionPopover = ({
  className,
  style,
  children,
  container = document.body,
  ...props
}: MentionPopoverProps) => (
  <Portal container={container}>
    <StyledDiv>
      <Popover {...props}>
        <Overlay.Container
          className={className}
          variant={Overlay.VARIANTS.LIGHT}
          style={[
            {
              position: 'static',
              width: 317,
              maxHeight: 350,
              overflow: 'auto',
              zIndex: theme.zIndex.tooltip,
            },
            style,
          ]}
        >
          <MenuList style={{ padding: '4px 0' }}>{children}</MenuList>
        </Overlay.Container>
      </Popover>
    </StyledDiv>
  </Portal>
);

MentionPopover.displayName = 'MentionPopover';

export default MentionPopover;
